<button
  class="button"
  [attr.aria-label]="ariaLabel()"
  [type]="htmlType()"
  [disabled]="disabled()"
  [class.button--x-small]="size() === 'x-small'"
  [class.button--small]="size() === 'small'"
  [class.button--medium]="size() === 'medium'"
  [class.button--table-small]="size() === 'table-small'"
  [class.button--input-btn]="size() === 'input-btn'"
  [class.button--large]="size() === 'large'"
  [class.button--primary]="type() === 'primary'"
  [class.button--secondary]="type() === 'secondary'"
  [class.button--tertiary-table]="type() === 'tertiary-table'"
  [class.button--tertiary]="type() === 'tertiary'"
  [class.button--add-voucher]="addVoucherButton()"
  (click)="handleOnClick()"
>
  <ng-content></ng-content>
  @if (loading()) {
    <span class="button__spinner"></span>
  }
</button>
